import React from 'react';
import AnnualRateCutsCard from './AnnualRateCutsCard';
import EndOfYearRateCard from './EndOfYearRateCard';
import FOMCMeetingCard from './FOMCMeetingCard';

function FedWatchSection({ data }) {
  const annual = data?.annual_outlook;
  const meetings = data?.meetings || [];
  const errors = data?.errors || [];

  return (
    <div className="space-y-3">
      <div>
        <h3 className="text-lg font-semibold text-white">Fed Watch</h3>
        <p className="text-xs text-gray-500">FOMC meeting calendar · Polymarket-implied probabilities</p>
      </div>

      {errors.length > 0 && (
        <div className="bg-yellow-900/20 border border-yellow-700 rounded-md p-2 text-yellow-200 text-xs">
          Polymarket fetch issue: {errors.map((e) => e.message).join('; ')}
        </div>
      )}

      <AnnualRateCutsCard data={annual} />

      <EndOfYearRateCard data={data?.rate_end_of_year} />

      <div className="grid grid-cols-12 gap-4">
        {meetings.map((m) => (
          <div key={m.meeting_date} className="col-span-12 sm:col-span-6 lg:col-span-3">
            <FOMCMeetingCard meeting={m} />
          </div>
        ))}
      </div>
    </div>
  );
}

export default FedWatchSection;
